/**
 * Back to Top — Mostra/esconde botão flutuante e rola ao topo suave.
 * Também intercepta o link .footer-back-top do rodapé pra rolar suave em vez de pular.
 *
 * Nota: usa addEventListener nativo com { passive: false } no link do rodapé pra escapar
 * do wrapper do eventlistener.js que força passive:true em todos os handlers jQuery
 * (bloqueia preventDefault e mata o smooth scroll em páginas internas).
 */
$(function () {
    var $backTop = $('#backToTop');

    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if ($backTop.length) {
        // Mostra/esconde com scroll
        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 400) {
                $backTop.addClass('visible');
            } else {
                $backTop.removeClass('visible');
            }
        });

        // Click no botão flutuante
        $backTop.on('click', scrollToTop);
    }

    // Link "Voltar ao Topo" do rodapé — event listener nativo com passive:false
    document.querySelectorAll('.footer-back-top').forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            scrollToTop();
        }, { passive: false });
    });
});
